"use client";
import { jsxs as j, jsx as l } from "react/jsx-runtime";
import { cva as k } from "class-variance-authority";
import { forwardRef as z, useRef as C, useImperativeHandle as R, useState as S, useCallback as d } from "react";
import { Text as w } from "../Text/Text.mjs";
import { cn as p } from "../../../utils/utils.mjs";
import { getGroupFocusWithinAccessibleStyles as W } from "../../../utils/styles.mjs";
const Z = k(
  `
    flex
    flex-col
    size-full
    rounded-sm
    border
    border-dashed
    p-3
    min-h-[7.5rem]
    min-w-[15rem]
    justify-center
    transition-colors
    
    dark:bg-neutral-dark-200
    dark:text-neutral-dark-600
    `,
  {
    variants: {
      state: {
        default: "dark:border-neutral-dark-300",
        loading: "dark:border-neutral-dark-500",
        error: "border-red-400 dark:border-red-400",
        success: "dark:border-neutral-dark-300 min-h-0"
      },
      isDragActive: {
        true: "border-gray-300 dark:border-neutral-dark-600",
        false: ""
      }
    },
    defaultVariants: {
      isDragActive: !1
    }
  }
), G = k(
  `
    text-left
    `,
  {
    variants: {
      state: {
        default: "",
        loading: "",
        success: "",
        error: "text-red-100"
      }
    },
    defaultVariants: {
      state: "default"
    }
  }
), H = z(
  ({
    className: b,
    wrapperClassName: v,
    state: c = "default",
    children: g,
    useButtonWrapper: h = !0,
    helperText: u,
    onPickFile: x,
    onFileDrop: e,
    onDragEnter: a,
    onDragOver: r,
    onDragLeave: s,
    onDrop: i,
    ...y
  }, A) => {
    const f = C(null);
    R(A, () => f.current);
    const [o, n] = S(!1), N = d(
      (t) => {
        t.preventDefault(), t.stopPropagation(), n(!0), a == null || a(t);
      },
      [a]
    ), T = d(
      (t) => {
        t.preventDefault(), t.stopPropagation(), r == null || r(t);
      },
      [r]
    ), I = d(
      (t) => {
        t.preventDefault(), t.stopPropagation(), !t.currentTarget.contains(t.relatedTarget) && (n(!1), s == null || s(t));
      },
      [s]
    ), P = d(
      (t) => {
        t.preventDefault(), t.stopPropagation(), n(!1), t.dataTransfer.files.length > 0 && (e == null || e(t.dataTransfer.files)), i == null || i(t);
      },
      [e, i]
    ), V = p(
      Z({ isDragActive: o, state: c }),
      W(),
      b
    ), m = /* @__PURE__ */ l(
      "div",
      {
        "data-testid": "interactive-zone",
        "data-drag-active": o || void 0,
        onDragEnter: N,
        onDragOver: T,
        onDragLeave: I,
        onDrop: P,
        className: V,
        children: g
      }
    );
    return /* @__PURE__ */ j("div", { className: p("flex flex-col gap-2 group", v), children: [
      h ? /* @__PURE__ */ l("button", { type: "button", onClick: x, children: m }) : m,
      /* @__PURE__ */ l("input", { ref: f, type: "file", className: "sr-only", ...y }),
      u && /* @__PURE__ */ l(w, { fontWeight: "regular", fontSize: "xs", className: G({ state: c }), children: u })
    ] });
  }
);
H.displayName = "FileInput";
export {
  H as FileInput
};
